module.exports = __webpack_public_path__ + "img/wechat.c1695cc0.png";